<template>
	<div class="container">
		<div class="video-box">
			<div class="main-screen">
				<div @click="toMiniVideo" id="mainContainer" class="video">
				</div>
				<div class="file-box">
					<button class="file-btn"><i></i>会议文档</button>
				</div>
				<div class="opa-box">
					<ul>
						<li>
							<div><i class="mkf"></i></div>
							<div class="desc">麦克风</div>
						</li>
						<li @click="stopMeeting">
							<div><i class="gd"></i></div>
							<div class="desc">离开会议</div>
						</li>
						<li>
							<div><i class="sxt"></i></div>
							<div class="desc">摄像头</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="right-list">
				<div class="top-tab">
					<span @click="tabIndex=0" v-bind:class="{selected:tabIndex==0}" class="tab-title">参会画面</span>
					<span @click="tabIndex=1" v-bind:class="{selected:tabIndex==1}" class="tab-title">会员列表</span>
				</div>
				<div class="bottom-content">
					<div v-show="tabIndex==0">
						<div  class="video-min-box">
							<div @click="beMainScreen(0)" class="video-min" id="video1"></div>
							<label class="order-number">1</label>
							<label class="user-name">主持人(222)</label>
						</div>
						<div @click="beMainScreen(2)" class="video-min" id="video2"></div>
						<div @click="beMainScreen(3)" class="video-min" id="video3"></div>
						<div @click="beMainScreen(4)" class="video-min" id="video4"></div>
						<div @click="beMainScreen(5)" class="video-min" id="video5"></div>
						<div @click="beMainScreen(6)" class="video-min" id="video6"></div>
					</div>
					<div class="border" v-show="tabIndex==1">
						<div class="search-box">
							<input type="text" v-model="keywords" placeholder="请输入关键词" @keyup.enter='search' />
							<el-button type="primary" icon="el-icon-search" @click='search'></el-button>
						</div>
						<div class="meeting-users">
							<ul>
								<li v-if="userList[0]" class="monitor border-bottom">
									{{userList[0].name}}(主持人)
									<i class="mini-mkf" v-bind:class="{'mini-mkf-jy':userList[0].jy==1}"></i>
								</li>
								<li v-for="(item,index) in userList" class="monitor border-bottom" v-if="index!=0">
									<div>
										<label>{{item.name}}({{loginModel.id==item.id?'我':''}})</label>
										<i class="mini-tc"></i>
									</div>
									<div>
										<button class="start" v-if="item.sp==0">结束视频连线</button>
										<button class="stop" v-if="item.sp==1">结束视频连线</button>
										<button class="agree" @click="agreeVideo(item)" v-if="item.sp==2">同意视频连线</button>
										<i class="mini-mkf" v-bind:class="{'mini-mkf-jy':item.jy==1}"></i>
									</div>
								</li>
								<li class="people border-bottom">
									<div>
										<label>XXX(我)</label>
										<i class="mini-mkf"></i>
									</div>
									<div>
										<button class="agree">同意视频连线</button>
										<i class="mini-mkf mini-mkf-jy"></i>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="meeting-control">
					<div class="all-jy">
						<button @click="allJy">全体静音</button>
					</div>
					<div class="all-sp">
						<button></button>
					</div>
				</div>
			</div>
		</div>
		<div class="mt20">
			<button class="mr20" @click="createChannel">创建房间</button>
			<button class="mr20" @click="joinChannel">进入会议</button>
			<!--<button @click="beMainScreen">进入主屏</button>-->
			<button @click="startAllVideo">开启视频</button>
			<button @click="stopAllVideo">禁止视频</button>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState, mapMutations } from 'vuex'
	/*import NIM_Web_WebRTC from '../../../../js/NIM_Web_WebRTC_v7.2.0'
	import NIM from '../../../../js/NIM_Web_NIM_v7.2.0'*/
	import meeting from '../../js/meeting';
	const miniVideoSize={
		width:150,
		height:86
	}
	export default {
		data() {
			return {
				keywords:"",
				tabIndex:0,
				list: [],
				Netcall:null,
				netcall:null,
				nim:null,
				channelId:0,//房间id
				mainContainer:{},
				channelName:'',
				screenAccids:[],
				monitorModel:{
					id:1,
					account:'4@cxf',
				},
				loginModel:{
					id:1
				},
				userList:[
					{id:1,name:'曹晓芳',accid:'4@cxf',jy:1,sp:1},
					{id:2,name:'乐云山',accid:'8@leys',jy:0,sp:2},
					{id:2,name:'乐云山1',accid:'8@leys',jy:0,sp:2},
				],
				mainScreen:{},
				teamId:2771128166,//群id
			}
		},
		created(){
			this.initIm();
		},
		mounted() {
			this.loadList();
			this.mainContainer = this.publicFunction.getEleWidthHeight("mainContainer");
		},
		computed: {},
		methods: {
			...mapActions([
				"getPaperDailyPageList"
			]),
			search(){

			},
			isMonitor(){
				return this.monitorModel.id==this.loginModel.id;
			},
			loadList() {
				this.getPaperDailyPageList({}).then(rtn => {
					this.list = rtn;
				});
			},
			//全体静音
			allJy(){
				this.sendMsg(WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_AUDIO_OFF);
			},
			stopAllVideo(){
				this.sendMsg(WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_OFF)
			},
			startAllVideo(){
				this.sendMsg(WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_ON)
			},
			//实现消息的全员通知，目前无法实现全员的通知，所以以发送通话控制信息的方式来实现
			//type的值如下：
			//WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_AUDIO_ON 全体放开静音
			//WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_AUDIO_OFF 全体静音
			//WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_ON 全体放开视频
			//WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_OFF 全体禁止开启视频
			//WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_OFF 全体禁止开启视频
			//WebRTC.NETCALL_CONTROL_COMMAND_SWITCH_AUDIO_TO_VIDEO //某个用户主动关闭了摄像头
			//WebRTC.NETCALL_CONTROL_COMMAND_SWITCH_AUDIO_TO_VIDEO //某个用户主动关闭了摄像头
			sendMsg(type){
				// 通知对方自己关闭了摄像头
				var param = {
					channelId: this.channelId,
					command: type
				}
				this.getNetcall().control(param)
			},
			stopMeeting(){
				this.getNetcall().leaveChannel()
			},
			initIm(){//初始化IM
				let data = {};
				this.nim = NIM.getInstance({
					debug: true,
					appKey: '6c65c8df4d9c7852c10a1ecaa1ad4182',
					/*socketUrl: 'weblink07.netease.im',*/
					/*privateConf: {
						nos_uploader_web:'http://10.173.38.38:18013',//设置文件上传代理地址
						nos_downloader:'http://10.173.38.38:18014'//设置文件下载代理地址
					},*/
					account: '8@leys',
					token:'780eb6977763cee5fa546e25848bc36a',
					//transports: ['xhr-polling'],
					db: true,//不使用数据库
					onconnect: this.onConnect,
					onerror: this.onError,
					oncustomsysmsg: this.onCustomSysMsg,//收到自定义通知处理
				});
			},
			onCustomSysMsg(sysMsg){
				let data = JSON.parse(sysMsg.apnsText);
				let _this = this;
				switch(data.type ) {
					case 1://开启声音
						meeting.startAudio(this.getNetcall(),WebRTC);
						break;
					case 2://关闭声音
						meeting.stopAudio(this.getNetcall(),WebRTC).then(function () {
							this.sendMsg(WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_ON)
						});
						break;
					case 3://开启摄像头
						meeting.startVideo(this.getNetcall(),WebRTC);
						break;
					case 4://禁用摄像头
						meeting.stopVideo(this.getNetcall(),WebRTC).then(function () {
							this.sendMsg(WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_ON)
						});
						break;
					case 5://离开房间
						meeting.leaveChannel(this.getNetcall(),WebRTC);
						break;
					default:
				}
			},
			onError(error) {
				console.log("111"+error);
			},
			//获取可用的容器
			findValideVideoContainer(account){
				if(account==this.monitorModel.account){
					this.screenAccids[0] = account;
					return 'video1';
				}
				for(let i=1;i<6;i++){
					if(!this.screenAccids[i]){
						return 'video'+i;
					}
				}
			},
			onConnect() {
				NIM.use(WebRTC);
				let _this = this;
				let netcall = this.getNetcall();

				netcall.on('devices', function (obj) {
					console.log('on devices', obj)
				})
				//收到远端数据回调
				netcall.on('remoteTrack', function (obj) {
					// 播放对方声音
					netcall.startDevice({
						type: WebRTC.DEVICE_TYPE_AUDIO_OUT_CHAT
					}).catch(function (err) {
						console.log('播放对方的声音失败')
						console.error(err)
					})
					// 预览对方视频画面
					//netcall.setPlayVolume(0)
					netcall.startRemoteStream({
						account: obj.account,
						node: document.getElementById(_this.findValideVideoContainer(obj.account))
					})

					// 设置对方预览画面大小
					netcall.setVideoViewRemoteSize({
						account: obj.account,
						width: 150,
						height:86,
						cut: false
					})
					_this.addOnControl();
				})

			},
			//添加消息通知监听，主要用于静音、禁止视频等
			addOnControl(){
				let _this = this;
				this.getNetcall().on('control', function(obj) {
					console.info(obj);
					// 如果不是当前通话的指令, 直接丢掉
					if (netcall.notCurrentChannelId(obj)) {
						return
					}
					switch(obj.command) {
						case WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_AUDIO_ON://放开静音
							meeting.startAudio(_this.getNetcall(),WebRTC);
							break;
						case WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_AUDIO_OFF://全体静音
							meeting.stopAudio(_this.getNetcall(),WebRTC);
							break;
						case WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_ON://开启摄像头
							meeting.startVideo(_this.getNetcall(),WebRTC,miniVideoSize.width,miniVideoSize.height);
							break;
						case WebRTC.NETCALL_CONTROL_COMMAND_NOTIFY_VIDEO_OFF://管理员禁用全体摄像头
							meeting.stopVideo(_this.getNetcall(),WebRTC).then(function () {
								_this.screenAccids=[];
							});
							break;
						case WebRTC.NETCALL_CONTROL_COMMAND_SWITCH_AUDIO_TO_VIDEO://某个用户主动关闭了摄像头，则需要通知其他用户把显示位置腾空
							for(let i=0;i<6;i++){
								if(_this.screenAccids[i]==obj.account){
									_this.screenAccids[i]=0;
								}
							}
							break;
						default:
					}
				})
			},
			getNetcall(){
				if(!this.netcall){
					this.netcall = WebRTC.getInstance({
						debug: true,
						nim: this.nim,
						/*container: document.getElementById('mainContainer'),
						remoteContainer: document.getElementById("video2"),*/
					});
				}
				return this.netcall;
			},
			createChannel(){
				let _this = this;
				this.getNetcall().createChannel({
					channelName: 'testChannelName2', //必填
					custom: '自定义数据', //可选
					webrtcEnable: true, //启动webrtc
					rtmpConf: '' //如果不需要房间推流，设置''，即可
				}).then(function(obj) {
					console.info("创建房间成功了")
					// 预定房间成功后的上层逻辑操作
					// eg: 初始化房间UI显示
					// eg: 加入房间

					_this.joinChannel();
				})
			},
			toMiniVideo(){
				let netcall = this.getNetcall();
				netcall.stopRemoteStream('8@leys');
			},
			beMainScreen(index){
				// 预览加入的同学的视频流
				this.getNetcall().startRemoteStream({
					account: this.screenAccids[index],
					node: document.getElementById('mainContainer')
				});
			},
			joinChannel(){
				const sessionConfig = {
					videoQuality: WebRTC.CHAT_VIDEO_QUALITY_HIGH,
					videoFrameRate: WebRTC.CHAT_VIDEO_FRAME_RATE_15,
					videoEncodeMode: WebRTC.CHAT_VIDEO_ENCODEMODE_NORMAL,
					videoBitrate: 0,
					recordVideo: false,
					recordAudio: false,
					highAudio: false,
					bypassRtmp: false,
					rtmpUrl: '',
					rtmpRecord: false,
					splitMode: WebRTC.LAYOUT_SPLITLATTICETILE
				};
				let _this = this;

				let netcall = this.getNetcall();
				netcall.joinChannel({
					channelName: 'testChannelName2', //必填
					type: WebRTC.NETCALL_TYPE_VIDEO,
					role: 0,//以互动者的身份加入
					sessionConfig: sessionConfig
				})
						.then(function(obj) {
							// 加入房间成功后的上层逻辑操作
							// eg: 开启摄像头
							// eg: 开启麦克风
							// eg: 开启本地流
							// eg: 设置音量采集、播放
							// eg: 设置视频画面尺寸等等，具体请参照p2p呼叫模式
							//加入房间成功之后，将自身加入到群组中
							netcall.startRtc().then(function() {
								_this.videoStreamin();
							});

						});
			},
			//音视频链接
			videoStreamin(){
				const netcall = this.getNetcall();
				let _this = this;
				meeting.startAudio(netcall,WebRTC)//启动麦克风
						.then(function () {
							return meeting.s
						})
						.then(function() {
							// 设置互动者角色
							netcall.changeRoleToPlayer()
						})
						.catch(function(err) {
							console.log(err)
							netcall.hangup()
						});
				if(this.isMonitor()){//主持人直接开启视频
					meeting.startVideo(netcall,WebRTC)
							.then(function () {
								//预览本地画面
								netcall.startLocalStream(
										document.getElementById('video1')
								)
								// 设置本地预览画面大小
								netcall.setVideoViewSize({
									width: 150,
									height: 86,
									cut:true
								})
							})
							.catch(function(err) {
								console.log(err)
								netcall.hangup()
							})
				}
			},
			agreeVideo(item){
				meeting.sendCustomSysMsg(this.nim,item.accid,{type:3})
			}
		}
	}
</script>
<style lang="scss" scoped type="text/css">


	.container {
		padding: 20px 20px 0 20px;
		box-sizing: border-box;
	}

	/*会议整体控制区域  开始*/
	.meeting-control{
		display: flex;
		background-color: #fff;
		padding:5px 0;
	}
	.meeting-control .all-sp{
		flex:3;
	}
	.meeting-control .all-jy button{
		background-color:#5D90E8 ;
		color:#fff;
		width:103px;
		height:24px;
	}
	.meeting-control .all-jy{
		text-align: center;
		flex:7;
	}
	/*会议整体控制区域  结束*/

	/*参会人列表  开始*/
	.meeting-users{
		line-height: 36px;
		padding:0 5px;
		background-color: #fff;
	}
	.meeting-users i{
		float:right;
		display: inline-block;
		background-size: 100% 100%;
	}
	.meeting-users .mini-tc{
		margin-top: 9px;
		width:14px;
		height: 16px;
		background-image: url(../../images/meetingManage/tc.png);
	}
	.meeting-users .mini-mkf{
		margin-top: 10px;
		width:10px;
		height: 16px;
		background-image: url(../../images/meetingManage/mini-mkf.png);
	}
	.meeting-users .mini-mkf-jy{
		background-image: url(../../images/meetingManage/mini-mkf-jy.png);
	}
	.meeting-users button{
		padding:0 3px;
	}
	.meeting-users .stop{
		background-color: #EE4839;
		color:#fff;
	}
	.meeting-users .agree{
		background-color: #5CCF69;
		color:#fff;
	}
	.meeting-users .start{
		background-color: #cdcdcd;
		color:#fff;
	}
	.meeting-users .people label{
		color:#999;
	}

	/*参会人列表  结束*/

	/*搜索框  开始*/
	.search-box {
		height: 30px;
		line-height: 30px;
		display: inline-block;
		overflow: hidden;
	}

	.search-box button {
		height: 28px;
		padding: 0;
		width: 28px;
		background-color: #fff;
		border: none;
		box-sizing: border-box;
	}

	.search-box button /deep/ .el-icon-search:before {
		font-size: 16px;
		color: #999;
	}
	.search-box /deep/ .el-button{
		border-radius: 0;
	}
	.search-box input {
		height: 28px;
		width: 120px;
		padding-left: 8px;
		border: none;
		box-sizing: border-box;
	}

	.search-box input:focus {
		outline: none;
	}
	/*搜索框  结束*/

	/*会员列表样式  开始*/
	.border{
		border:solid 1px #cdcdcd;
	}
	/*会员列表样式  结束*/

	/*主屏 按钮区 开始*/
	.opa-box {
		position: absolute;
		text-align: center;
		bottom: 75px;
		left:0;
		right:0
	}
	.opa-box ul{
		display: inline-block;
	}
	.opa-box li i.mkf{
		background-image: url(../../images/meetingManage/mkf.png);
	}
	.opa-box li i.gd{
		background-image: url(../../images/meetingManage/gd.png);
	}
	.opa-box li i.sxt{
		background-image: url(../../images/meetingManage/sxt.png);
	}
	.opa-box li i{
		display: inline-block;
		background-size: 100% 100%;
		width: 40px;
		height: 40px;
	}
	.opa-box li .desc{
		color:#fff;
		margin-top: 3px;
	}
	.opa-box li{
		opacity: 0.6;
		cursor: pointer;
	}
	.opa-box li:hover{
		opacity: 1;
	}
	.opa-box li{
		display: inline-block;
		margin: 0 20px;
	}
	/*主屏 按钮区 结束*/


	.video-box .top-tab .tab-title{
		text-align: center;
		display: inline-block;
		line-height: 38px;
		width: 75px;
		border: solid 1px;
		box-sizing: border-box;
		color:#999;
		background-color: #CDCDCD;
		cursor: pointer;
	}
	.video-box .top-tab .tab-title:last-child{
		border-left: none;
	}
	.video-box .top-tab .selected{
		color:#5D90E8;
		border: solid 1px;
		background-color: #fff;
	}
	.video-box .right-list{
		box-sizing: border-box;
		width: 150px;
	}
	.video-box .right-list .video-min-box{
		position: relative;
	}
	.video-box .right-list .user-name{
		color:#fff;
		position: absolute;
		left:5px;
		bottom: 5px;
	}
	.video-box .right-list .order-number{
		display: inline-block;
		position: absolute;
		top:5px;
		right:5px;
		text-align: center;
		border-radius: 50%;
		background-color: #cdcdcd;
		line-height: 15px;
		width:15px;
		height:15px;
		font-size: 12px;
	}
	.video-box .right-list .video-min{
		height: 86px;
		margin-top: 2px;
		background-color: #1f9fed;
	}
	.video-box .main-screen .file-box{
		line-height: 60px;
		background-color: #fff;
	}
	.video-box .file-btn i{
		vertical-align: -4px;
		margin:0 3px 0 20px;
		display: inline-block;
		width: 20px;
		height: 20px;
		background-image: url(../../images/meetingManage/hywd.png);
		background-size: 100% 100%;
	}
	.video-box .main-screen .file-btn{
		color:#999;
		background-color: #fff;
		vertical-align: middle;
	}
	.video-box .main-screen .video{
		height: 570px;
	}
	.video-box .main-screen{
		flex: 1;
		height:630px;
		margin-right: 20px;
		background-color: #1f9fed;
		border-radius:5px;
		position: relative;
	}
	.video-box{
		display: flex;
	}
	.video-container{
		width: 300px;
		height:200px;
		background-color: #1f9fed;
		border: solid 1px #f0f0f0;
	}

</style>